import { jsPDF } from "jspdf";
import "jspdf-autotable";

export const generateInvoice = (data, filename) => {
  const doc = new jsPDF();
  
  // Add logo
  // doc.addImage(logo, 'JPEG', 10, 10, 50, 20);
  
  // Invoice header
  doc.setFontSize(20);
  doc.text("INVOICE", 105, 20, { align: "center" });
  doc.setFontSize(10);
  doc.text(`Invoice #: ${data.invoiceNumber}`, 105, 30, { align: "center" });
  doc.text(`Date: ${data.date}`, 105, 35, { align: "center" });
  
  // Company info
  doc.setFontSize(12);
  doc.text("Bill To:", 15, 50);
  doc.setFontSize(10);
  doc.text(data.companyName, 15, 55);
  doc.text(data.companyAddress, 15, 60);
  doc.text(`Pincode: ${data.pincode}`, 15, 65);
  doc.text(`Phone: ${data.phoneNumber}`, 15, 70);
  
  // Invoice table
  const items = [
    {
      description: data.items[0].description,
      amount: `₹${data.items[0].amount}`,
    }
  ];
  
  doc.autoTable({
    startY: 80,
    head: [['Description', 'Amount']],
    body: items.map(item => [item.description, item.amount]),
    theme: 'grid',
    headStyles: {
      fillColor: [41, 128, 185],
      textColor: 255,
      fontStyle: 'bold'
    },
  });
  
  // Total
  doc.autoTable({
    startY: doc.lastAutoTable.finalY + 10,
    body: [['Total', `₹${data.total}`]],
    theme: 'plain',
    columnStyles: {
      0: { fontStyle: 'bold' },
      1: { fontStyle: 'bold', halign: 'right' }
    }
  });
  
  // Payment info
  doc.setFontSize(10);
  doc.text(`Payment ID: ${data.paymentId}`, 15, doc.lastAutoTable.finalY + 20);
  doc.text(`Transaction ID: ${data.transactionId}`, 15, doc.lastAutoTable.finalY + 25);
  
  // Footer
  doc.setFontSize(8);
  doc.text("Thank you for your business!", 105, doc.internal.pageSize.height - 10, { align: "center" });
  
  // Save the PDF
  doc.save(filename);
};